import React, {useEffect} from 'react'
import {useFieldValue, useFormSelector} from './context'

export const useNewRegisterField = (field, fieldProps) => {
	const registerField = useFormSelector('registerField')
	const unregisterField = useFormSelector('unregisterField')
	const enhanceField = useFormSelector('enhanceField')

	useEffect(() => {
		registerField?.(field, fieldProps)
		return () => unregisterField?.(field)
	}, [field, fieldProps?.required])

	const value = useFieldValue(field)
	const error = useFormSelector(`errors.${field}`)

	if (!enhanceField) return

	return enhanceField(field, {...fieldProps, value, error})
}

const FormField = ({props, Comp}) => {
	const formProps = useNewRegisterField(props.field, props)
	return <Comp {...props} {...formProps} form />
}

export const makeNewRegisteredField = Comp => props => {
	if (!props.field) return <Comp {...props} />

	return <FormField props={props} Comp={Comp} />
}
